<template>
  <div class="input-btn-container flex">
    <input
      ref="input"
      class="input-border"
      type="text"
      :placeholder="placeholder"
      @keyup.enter="add"
      v-select.focus
    />

    <div @click="add" class="btn  ">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: ["text", "placeholder"],
  methods: {
    add($event) {
      if (this.$refs.input.value)
        this.$emit("click", $event, this.$refs.input.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-btn-container {
  padding-bottom: 10px;
  padding-top: 10px;
}
</style>
